import { useSmartAccounts } from '~/hooks/useSmartAccounts'

export const useShowMultiSigSwapMessage = (smartAccountId?: string) => {
  const { smartAccounts } = useSmartAccounts()

  const smartAccount = smartAccounts.find(
    (account) => account.id === smartAccountId,
  )

  if (!smartAccount) {
    return false
  }

  return smartAccount.threshold > 1
}
